class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.autoCloseTimeout = null;
    this.autoCloseDuration = 5000;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (e) => {
      if (e.target.closest('button[type="button"]')) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      }
    });
  }

  connectedCallback() {
    this.bindCheckoutLink();
  }

  /** Colons in Shopify line-item keys break `#id` / attribute selectors unless escaped */
  cartLineCssSelector() {
    if (!this.cartItemKey) return '[id^="cart-notification-product-"]';
    const id = `cart-notification-product-${this.cartItemKey}`;
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return `#${CSS.escape(id)}`;
    }
    return '[id^="cart-notification-product-"]';
  }

  resolveCheckoutHref(link) {
    const raw = (link.getAttribute('href') || '').trim();
    if (raw && raw !== '#') {
      try {
        return new URL(raw, window.location.href).href;
      } catch {
        /* ignore */
      }
    }
    const fallback =
      typeof window !== 'undefined' && window.routes && window.routes.checkout_url
        ? String(window.routes.checkout_url).trim()
        : '';
    if (fallback) {
      try {
        return new URL(fallback, window.location.href).href;
      } catch {
        /* ignore */
      }
    }
    try {
      return new URL('/checkout', window.location.origin).href;
    } catch {
      return '/checkout';
    }
  }

  bindCheckoutLink() {
    if (this.checkoutLinkBound) return;
    const link = this.querySelector('a.cart-notification__checkout');
    if (!link) return;
    this.checkoutLinkBound = true;

    link.addEventListener(
      'click',
      (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        const href = this.resolveCheckoutHref(link);
        e.preventDefault();
        e.stopPropagation();
        window.location.assign(href);
      },
      true,
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.clearAutoClose();
    this.autoCloseTimeout = setTimeout(() => this.close(), this.autoCloseDuration);
  }

  close() {
    this.clearAutoClose();
    this.notification.classList.remove('active');
  }

  clearAutoClose() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = null;
    }
  }

  renderContents(parsedState) {
    const items = parsedState.items;
    this.cartItemKey =
      parsedState.key ||
      (Array.isArray(items) && items.length > 0 ? items[items.length - 1].key : '') ||
      items?.[0]?.key ||
      '';

    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el || !parsedState.sections?.[section.id]) return;

      let html = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );

      if (!html && section.id === 'cart-notification-product') {
        html = this.getLatestProductHTML(parsedState.sections[section.id]);
      }

      el.innerHTML = html;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getLatestProductHTML(sectionHTML) {
    const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    const first = doc.querySelector('[id^="cart-notification-product-"]');
    return first ? first.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: this.cartLineCssSelector(),
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
